import type { ComponentChildren } from "preact";

// Minimal bottom-sheet for quick entry (drinks, mood, caffeine).
export function Sheet({ title, onClose, children }: {
  title: string;
  onClose: () => void;
  children: ComponentChildren;
}) {
  return (
    <div class="sheet-backdrop" onClick={onClose}>
      <div class="sheet" onClick={(e) => e.stopPropagation()}>
        <h2>{title}</h2>
        {children}
      </div>
    </div>
  );
}
